export enum CoreInfoRequestReasonTypeEnum {
  Tso = 0,
  Tsr = 1,
  Tsn = 2,
  Cso = 3,
  Csr = 4,
  Csn = 5,
  Dsr = 6,
  Dsn = 7,
  NewF1 = 8,
  DetailedRemovalReason = 9,
  Nis = 10,
  Pfr = 11,
  Arl = 12,
  IpcCmm = 13,
  WarrantyRef = 14,
  Dom = 15,
  UnusedStatement = 16,
  Nha = 17,
  Nla = 18,
  LastShopReport = 19,
  UsTag = 20,
  LastTestCertification = 21,
  ShippingInvoice = 22,
  PackingSlip = 23,
  AdSbMod = 24,
  LastOhCertification = 25,
  LastRepairCertification = 26,
  Dso = 27,
  Tsi = 28,
  Csi = 29,
  Dsi = 30,
  TsnAndCsnStatement = 31,
  PnAndSnStatement = 32,
  MaintenanceRecord = 33,
  BackToBirth = 34,
  EngineSerialNumber = 35,
}

export const GetCoreInfoRequestReasonTypeEnum = [
  { Value: 0, Description: "TSO" },
  { Value: 1, Description: "TSR" },
  { Value: 2, Description: "TSN" },
  { Value: 3, Description: "CSO" },
  { Value: 4, Description: "CSR" },
  { Value: 5, Description: "CSN" },
  { Value: 6, Description: "DSR" },
  { Value: 7, Description: "DSN" },
  { Value: 8, Description: "New F1" },
  { Value: 9, Description: "Detailed Removal Reason" },
  { Value: 10, Description: "NIS" },
  { Value: 11, Description: "PFR" },
  { Value: 12, Description: "ARL" },
  { Value: 13, Description: "IPC CMM" },
  { Value: 14, Description: "Warranty Ref" },
  { Value: 15, Description: "DOM" },
  { Value: 16, Description: "Unused Statement" },
  { Value: 17, Description: "NHA" },
  { Value: 18, Description: "NLA" },
  { Value: 19, Description: "Last Shop Report" },
  { Value: 20, Description: "US-TAG" },
  { Value: 21, Description: "Last Test Certification" },
  { Value: 22, Description: "Shipping Invoice" },
  { Value: 23, Description: "Packing Slip" },
  { Value: 24, Description: "AD/SB/MOD" },
  { Value: 25, Description: "Last OH Certification" },
  { Value: 26, Description: "Last Repair Certification" },
  { Value: 27, Description: "DSO" },
  { Value: 28, Description: "TSI" },
  { Value: 29, Description: "CSI" },
  { Value: 30, Description: "DSI" },
  { Value: 31, Description: "TSN And CSN Statement" },
  { Value: 32, Description: "PN And SN Statement" },
  { Value: 33, Description: "Maintenance Record" },
  { Value: 34, Description: "Back To Birth" },
  { Value: 35, Description: "Engine Serial Number" },
];
